

import ClientHead from "@/components/main/core/ClientHead";

export default {

  head() {
    const title = 'Site Map ᐈ iFindCheaters';
    const description = 'List of all important and useful pages ⏩ iFindCheaters';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/sitemap/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Site Map",
            }],
          }
        }
      ]
    };
  },

  name: "sitemap",
  layout: 'clientLayout',
  mixins: [],
  components: {ClientHead, },
  data() {
    return {
      postsData: null,
    }
  },

  async mounted() {
    try {
      const postsResponse = await this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/all`);
      this.postsData = postsResponse.data.data;
    } catch (error) {
      console.error('Error:', error);
    }
  },

  computed: {

  },

  methods: {
    capitalizeWords(str) {
      return str.toLowerCase().replace(/\b\w/g, function(l) {
        return l.toUpperCase();
      });
    }
  }
}
